import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import scrollLock from 'scroll-lock';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe.components/common/modal/modal.indra.service';
import { SidebarService } from '@ibe/services/ui';


@Component({
  selector: 'app-signup-error-modal',
  templateUrl: './signup-error-modal.component.html',
  styleUrls: ['./signup-error-modal.component.scss']
})
export class INDRASignupErrorModalComponent extends AbstractModalContentComponent implements OnInit{

	htmlElement = document.getElementsByTagName('html')


	constructor(protected modalService: ModalService, private router: Router, private sidebarService: SidebarService) {
		super(modalService);
		this.TYPE = 'dialog';
	  }

	ngOnInit() {
	  }

	  TAP_goWithoutDiscount() {
		  this.modalService.close();
			this.sidebarService.closeSidebar();
	  }


	  closeModal() {
		  this.modalService.close();
		  if (this.htmlElement[0].classList.contains('no-scroll')) {
			  this.htmlElement[0].classList.remove('no-scroll');
			  scrollLock.show();
			}

		}

		TAP_newSearch(){
			this.modalService.close();
			this.sidebarService.closeSidebar();
		}

}
